export { default } from './MapCreateSpotType';
